var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { CuratedPackageManager } from "../manager";
var CuratedPackageWrapper = /** @class */ (function (_super) {
    __extends(CuratedPackageWrapper, _super);
    function CuratedPackageWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            curated: props.curated
        };
        return _this;
    }
    CuratedPackageWrapper.prototype.componentWillReceiveProps = function (newProps) {
        var _this = this;
        if (newProps.curated && this.state.curated && newProps.curated.id === this.state.curated.id) {
            if (new Date(newProps.curated.updated_at) > new Date(this.state.curated.updated_at)) {
                this.setState({ curated: newProps.curated });
            }
        }
        else {
            this.unregisterListener();
            this.setState({ curated: newProps.curated }, function () { _this.registerListener(); });
        }
    };
    CuratedPackageWrapper.prototype.componentDidMount = function () {
        this.registerListener();
    };
    CuratedPackageWrapper.prototype.componentWillUnmount = function () {
        this.unregisterListener();
    };
    CuratedPackageWrapper.prototype.registerListener = function () {
        var _this = this;
        this._postsStateListener = CuratedPackageManager.getInstance().addCuratedPackageStateListener(this.state.curated, function (curated) {
            if (_this.state.curated.id === curated.id) {
                _this.setState({ curated: curated });
            }
        });
    };
    CuratedPackageWrapper.prototype.unregisterListener = function () {
        this._postsStateListener && CuratedPackageManager.getInstance().removeCuratedPackageStateListener(this.props.curated, this._postsStateListener);
    };
    CuratedPackageWrapper.prototype.render = function () {
        var curated = this.state.curated;
        return this.props.children(curated);
    };
    return CuratedPackageWrapper;
}(React.Component));
export default CuratedPackageWrapper;
//# sourceMappingURL=soundpackage.js.map